module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.scss
// module id = ./src/app/header/header.component.scss
// module chunks = main